import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as alertTypes from 'common/alerts/containers/alert-constants';
import * as actionTypes from './constants';

export const data = handleActions(
  {
    [actionTypes.DASHBOARD_REQUEST]: () => ({}),
    [actionTypes.DASHBOARD_SUCCESS]: (state, { payload }) => payload.details,
    [combineActions(
      actionTypes.SAVE_NOTES_SUCCESS,
      actionTypes.FETCH_NOTES_SUCCESS,
    )]: (state, { payload }) => ({ ...state, notes: payload.notes }),
  },
  {},
);

export const isNotesLoading = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_NOTES_SUCCESS,
      actionTypes.SAVE_NOTES_FAILURE,
      actionTypes.FETCH_NOTES_SUCCESS,
      actionTypes.FETCH_NOTES_FAILURE,
    )]: () => false,
    [combineActions(actionTypes.SAVE_NOTES_REQUEST, actionTypes.FETCH_NOTES_REQUEST)]: () => true,
  },
  false,
);

export const saveNotesSuccess = handleActions(
  {
    [combineActions(
      actionTypes.SAVE_NOTES_REQUEST,
      actionTypes.SAVE_NOTES_FAILURE,
      actionTypes.FETCH_NOTES_REQUEST,
      actionTypes.RESET_SAVE_NOTES_SUCCESS,
    )]: () => false,
    [combineActions(actionTypes.SAVE_NOTES_SUCCESS)]: () => true,
  },
  false,
);

export const isLoading = handleActions(
  {
    [combineActions(actionTypes.DASHBOARD_SUCCESS, actionTypes.DASHBOARD_FAILURE)]: () => false,
    [actionTypes.DASHBOARD_REQUEST]: () => true,
  },
  false,
);

export const notesError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.SAVE_NOTES_SUCCESS,
      actionTypes.SAVE_NOTES_REQUEST,
      actionTypes.FETCH_NOTES_SUCCESS,
      actionTypes.FETCH_NOTES_REQUEST,
    )]: () => ({}),
    [combineActions(
      actionTypes.SAVE_NOTES_FAILURE,
      actionTypes.FETCH_NOTES_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.DASHBOARD_REQUEST,
      actionTypes.DASHBOARD_SUCCESS,
      alertTypes.ALERT_SNOOZE_REQUEST,
      alertTypes.ALERT_SNOOZE_SUCCESS,
      alertTypes.ALERT_DISCARD_REQUEST,
      alertTypes.ALERT_DISCARD_FAILURE,
    )]: () => ({}),
    [combineActions(
      actionTypes.DASHBOARD_FAILURE,
      alertTypes.ALERT_SNOOZE_FAILURE,
      alertTypes.ALERT_DISCARD_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  data,
  isLoading,
  error,
  isNotesLoading,
  notesError,
  saveNotesSuccess,
});
